define(
	'TavanoTeam.PDPFAQ.PDPFAQ'
,	[
		'ProductDetails.Information.View'
	,	'jQuery'
	,	'underscore'
	]
,	function (
		ProductDetailsInformationView
	,	jQuery
	,	_
	)
{
	'use strict';

	var FAQ_JSONLD_ID = 'tt-faq-jsonld';
	var PDP_FULL_VIEW_ID = 'ProductDetails.Full.View';
	var PDP_QUICK_VIEW_ID = 'ProductDetails.QuickView.View';

	function resolveViewId (viewArg)
	{
		if (!viewArg)
		{
			return '';
		}

		if (typeof viewArg === 'string')
		{
			return viewArg;
		}

		return (viewArg.attributes && viewArg.attributes.id) || viewArg.id || '';
	}

	function removeFaqJsonLd ()
	{
		var existing = document.getElementById(FAQ_JSONLD_ID);

		if (existing && existing.parentNode)
		{
			existing.parentNode.removeChild(existing);
		}
	}

	function upsertFaqJsonLd (schema)
	{
		removeFaqJsonLd();

		if (!schema || !schema.mainEntity || !schema.mainEntity.length)
		{
			return;
		}

		var head = document.head || document.getElementsByTagName('head')[0];

		if (!head)
		{
			return;
		}

		var script = document.createElement('script');
		script.type = 'application/ld+json';
		script.id = FAQ_JSONLD_ID;
		script.text = JSON.stringify(schema).replace(/</g, '\\u003c');
		head.appendChild(script);
	}

	return {
		mountToApp: function mountToApp (container)
		{
			// Keep original/custom computeDetailsArea (e.g. from PDP_Extension) and inject FAQs.
			// Prefer activation order so this extension loads AFTER PDP_Extension
			// (PDP_Extension_FAQ sorts after PDP_Extension alphabetically).
			var originalComputeDetailsArea = ProductDetailsInformationView.prototype.computeDetailsArea;
			var layout = container.getComponent('Layout');
			var pdp = container.getComponent('PDP');

			ProductDetailsInformationView.prototype.normalizeFaqHtml = function normalizeFaqHtml (faqHtml)
			{
				var faqHtmlStr = String(faqHtml || '').trim();

				if (!faqHtmlStr)
				{
					return '';
				}

				// Ensure outer wrapper for SSR when NetSuite omits it.
				if (faqHtmlStr.indexOf('tt-product-details-faq') === -1)
				{
					faqHtmlStr = '<div class="tt-product-details-faq">' + faqHtmlStr + '</div>';
				}

				return faqHtmlStr;
			};

			ProductDetailsInformationView.prototype.getFaqRoot = function getFaqRoot (faqHtml)
			{
				var $root = jQuery('<div class="tt-product-details-faq"></div>').html(faqHtml);
				var $onlyChild = $root.children();

				// Avoid double-wrapping when NetSuite already provides the outer container.
				if ($onlyChild.length === 1 && $onlyChild.first().hasClass('tt-product-details-faq'))
				{
					$root = $onlyChild.first();
				}

				return $root;
			};

			ProductDetailsInformationView.prototype.parseFaqPairs = function parseFaqPairs (faqHtml)
			{
				var pairs = [];

				if (!faqHtml || !String(faqHtml).trim())
				{
					return pairs;
				}

				this.getFaqRoot(faqHtml).find('.tt-product-details-faq-item').each(function ()
				{
					var $item = jQuery(this);
					var question = jQuery.trim($item.find('.tt-product-details-faq-question').first().text() || '');
					var answer = jQuery.trim($item.find('.tt-product-details-faq-answer').first().text() || '');

					if (question && answer)
					{
						pairs.push({
							name: question
						,	text: answer
						});
					}
				});

				return pairs;
			};

			ProductDetailsInformationView.prototype.buildFaqPageSchema = function buildFaqPageSchema (pairs)
			{
				var mainEntity = _.map(pairs || [], function (pair)
				{
					return {
						'@type': 'Question'
					,	name: pair.name
					,	acceptedAnswer: {
							'@type': 'Answer'
						,	text: pair.text
						}
					};
				});

				return {
					'@context': 'https://schema.org'
				,	'@type': 'FAQPage'
				,	mainEntity: mainEntity
				};
			};

			ProductDetailsInformationView.prototype.prepareFaqCollapseHtml = function prepareFaqCollapseHtml (faqHtml, itemId)
			{
				if (!faqHtml || !String(faqHtml).trim())
				{
					return '';
				}

				var $root = this.getFaqRoot(faqHtml);
				var idPrefix = 'tt-faq-' + (itemId || 'item') + '-';

				$root.find('.tt-product-details-faq-item').each(function (index)
				{
					var $item = jQuery(this);
					var $question = $item.find('.tt-product-details-faq-question').first();
					var $answer = $item.find('.tt-product-details-faq-answer').first();

					if (!$question.length || !$answer.length)
					{
						return;
					}

					var collapseId = idPrefix + index;

					$answer.attr('id', collapseId);
					$answer.addClass('collapse');

					$question.attr({
						'data-toggle': 'collapse'
					,	'data-target': '#' + collapseId
					,	'aria-expanded': 'false'
					,	'aria-controls': collapseId
					,	role: 'button'
					});
					$question.addClass('collapsed');
				});

				return jQuery('<div></div>').append($root.clone()).html();
			};

			ProductDetailsInformationView.prototype.computeDetailsArea = function computeDetailsArea ()
			{
				var details = [];

				if (typeof originalComputeDetailsArea === 'function')
				{
					details = originalComputeDetailsArea.apply(this, arguments) || [];
				}

				// Do not re-add if already present
				if (_.find(details, function (d) { return d && (d.isFaq || d.name === 'FAQs'); }))
				{
					return details;
				}

				var item = this.model && this.model.get('item');
				var itemAtt = item && (item.attributes || item);
				var faqHtmlRaw = itemAtt && itemAtt.custitem_tt_faq;

				if (!faqHtmlRaw || !String(faqHtmlRaw).trim())
				{
					return details;
				}

				// During SEO Page Generator, skip collapse DOM wrapping so FAQ HTML
				// is emitted as a plain string in the static page source.
				var preparedFaqHtml = SC.isPageGenerator()
					? this.normalizeFaqHtml(faqHtmlRaw)
					: this.prepareFaqCollapseHtml(faqHtmlRaw, itemAtt.internalid);

				if (!preparedFaqHtml)
				{
					return details;
				}

				var faqPanel = {
					name: 'FAQs'
				,	isFaq: true
				,	content: preparedFaqHtml
				};

				// Insert between Details and Documents & Videos when possible
				var insertAt = -1;

				for (var i = 0; i < details.length; i++)
				{
					if (details[i] && (details[i].isDocuments || details[i].name === 'Documents & Videos'))
					{
						insertAt = i;
						break;
					}
				}

				if (insertAt === -1)
				{
					details.push(faqPanel);
				}
				else
				{
					details.splice(insertAt, 0, faqPanel);
				}

				return details;
			};

			function isFullPdpView (viewId)
			{
				if (!viewId)
				{
					return false;
				}

				if (viewId === PDP_QUICK_VIEW_ID || (pdp && viewId === pdp.PDP_QUICK_VIEW))
				{
					return false;
				}

				return viewId === PDP_FULL_VIEW_ID || (pdp && viewId === pdp.PDP_FULL_VIEW);
			}

			function syncFaqJsonLd (viewArg)
			{
				try
				{
					var viewId = resolveViewId(viewArg);

					if (!isFullPdpView(viewId))
					{
						removeFaqJsonLd();
						return;
					}

					var itemInfo = pdp && pdp.getItemInfo();
					var item = itemInfo && itemInfo.item;
					var faqHtmlRaw = item && item.custitem_tt_faq;
					var pairs = ProductDetailsInformationView.prototype.parseFaqPairs(faqHtmlRaw);

					if (!pairs.length)
					{
						removeFaqJsonLd();
						return;
					}

					upsertFaqJsonLd(ProductDetailsInformationView.prototype.buildFaqPageSchema(pairs));
				}
				catch (e)
				{
					console.error('TavanoTeam.PDPFAQ JSON-LD Error:', e);
					removeFaqJsonLd();
				}
			}

			if (layout && layout.on)
			{
				layout.on('afterShowContent', function (viewArg)
				{
					syncFaqJsonLd(viewArg);
				});
			}

			// Ensure isFaq content renders with the existing info template (content triple-stache path).
			// If a later/custom template adds {{#if isFaq}}, that branch also works.
		}
	};
});
